<div class="w-full">
	<div id="custom-mat-slider" class="relative mx-auto flex h-[80px] w-full max-w-[896px] items-start justify-between">
		<div class="absolute top-0 w-full">
			<div class="custom-track-bg flex items-center justify-between">
				@for (step of stepsArray; track step) {
					<span></span>
				}
				<div></div>
			</div>
			<div class="custom-track-label">
				@for (step of stepsArray; track step) {
					<span>{{ step === 0 ? "Incomplete" : step }}</span>
				}
			</div>
			<div class="custom-track absolute top-0 flex w-full items-center justify-between">
				@for (step of stepsArray; track step) {
					<span [class.active]="currentSliderValue >= step" [class.current]="currentSliderValue === step"></span>
				}
				<div [style.width.%]="currentSliderValue * (100 / steps)"></div>
			</div>
		</div>
		<mat-slider
			class="absolute left-0 top-0 w-full"
			[min]="0"
			[max]="steps"
			[step]="1"
			[discrete]="true"
			[showTickMarks]="true"
		>
			<input matSliderThumb [value]="currentSliderValue" (valueChange)="onSliderDrag($event)" />
		</mat-slider>
	</div>
</div>
